import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Row, Spinner } from "react-bootstrap";
import { Skeleton } from "@mui/material";
import { ArrowRight } from "iconsax-react";

import ButtonComponent from "../../button";

import ActivityButtons from "./activityButton";
import LabReportDataComponent from "./labReportData";
import ActivityInformationComponent from "./activityInfo";

import { StyledContainer, ActivityButton } from "../labReport/styledLabReport";
import {
  StyledActivityContainer,
  LeftContent,
  RightContent,
  ButtonRow,
} from "./styledActivityTab";

const ActivityTab = ({
  isLoaded,
  loading,
  downloadPdf,
  editorContent,
  simReportData,
  error,
  uploadedImages,
  setLabReportSection,
  openSendActivityModal,
  teacherFeedBack,
}) => {
  const location = useLocation();
  const history = useHistory();

  const handleGoBack = () => {
    if (teacherFeedBack) {
      history.goBack();
    } else {
      setLabReportSection(true);
    }
  };

  const ActivityTabContainer = () => {
    return (
      <StyledContainer className="w-100 mx-auto p-0 d-flex flex-column">
        <Row className="header-wrapper mb-3 mb-md-5 mt-md-1 w-100 mx-auto p-0">
          <ArrowRight
            color="var(--text-color-dark)"
            className="arrow-right w-auto p-0"
            onClick={handleGoBack}
          />
          <h1 className="m-0 p-md-0 w-auto flex-sm-grow-1 text-center">
            گزارش فعالیت آزمایش&nbsp;{simReportData?.sim_name}
          </h1>
          {!location.state?.editFromProfile && (
            <ButtonComponent
              onClick={handleGoBack}
              className="go-back-button mx-2 mx-md-0 mb-1 mb-md-0"
            >
              بازگشت
            </ButtonComponent>
          )}
        </Row>
        <StyledActivityContainer className="mx-auto p-0">
          <RightContent>
            <ActivityInformationComponent simReportData={simReportData} />
          </RightContent>
          <LeftContent className="p-2 pb-5 p-md-3">
            <LabReportDataComponent
              lastEdit={
                simReportData?.finish_at ? simReportData?.finish_at : ""
              }
              handleGoBack={handleGoBack}
              editorContent={editorContent}
              uploadedImages={uploadedImages}
              lastEditLoading={!simReportData?.finish_at}
            />
          </LeftContent>
        </StyledActivityContainer>
        <ButtonRow
          className="mx-auto p-0 mt-5 mt-md-3"
          $teacherFeedBack={teacherFeedBack}
        >
          <ActivityButtons
            downloadPdf={downloadPdf}
            loading={loading}
            teacherFeedBack={teacherFeedBack}
            openSendActivityModal={openSendActivityModal}
          />
        </ButtonRow>
      </StyledContainer>
    );
  };
  const ActivityTabSkeleton = () => {
    return (
      <StyledContainer className="w-100 mx-auto p-0 d-flex flex-column">
        <Row className="header-wrapper w-100 mx-auto mb-3 mb-md-5 mt-md-1 p-0">
          <ArrowRight
            color="var(--text-color-dark)"
            className="arrow-right w-auto p-0"
          />
          <h1 className="m-0 p-md-0 w-auto flex-sm-grow-1 text-center">
            گزارش فعالیت آزمایش&nbsp;
          </h1>
          <ButtonComponent className="go-back-button mx-2 mx-md-0 mb-1 mb-md-0">
            بازگشت
          </ButtonComponent>
        </Row>
        <StyledActivityContainer className="mx-auto p-0">
          <RightContent>
            <Skeleton height={150} />
            <Skeleton height={150} />
            <Skeleton height={150} />
          </RightContent>
          <LeftContent className="p-2 pb-5 p-md-3">
            <Skeleton height={130} />
            <Skeleton height={130} />
            <Skeleton height={130} />
            <Skeleton height={130} />
          </LeftContent>
        </StyledActivityContainer>
        <ButtonRow
          className="mx-auto p-0 mt-5 mt-md-3"
          $teacherFeedBack={teacherFeedBack}
        >
          {teacherFeedBack ? (
            <ButtonComponent className="d-block mx-auto col-5 col-md-3 order-2 order-md-1">
              ثبت نمره
            </ButtonComponent>
          ) : (
            <>
              <ButtonComponent className="download-button">
                دانلود گزارش فعالیت
              </ButtonComponent>
              <ActivityButton $width="190px">ارسال گزارش فعالیت</ActivityButton>
            </>
          )}
        </ButtonRow>
      </StyledContainer>
    );
  };

  let element = null;
  if (error) {
    element = <p className="text-center">{error.detail}</p>;
  } else if (!isLoaded) {
    element = <ActivityTabSkeleton />;
  } else {
    element = <ActivityTabContainer />;
  }

  return element;
};

export default ActivityTab;
